import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import RequireAuth from './components/shared/RequireAuth';
import ForgotPassword from './screens/admin/ForgotPassword';
import Home from './screens/admin/Home';
import Login from './screens/admin/Login';
import ResetPassword from './screens/admin/ResetPassword';
import MyProfile from './screens/admin/UserProfile';
import ClientPermissions from './screens/admin/panel/ClientPermissions';
import Permissions from './screens/admin/panel/Permissions';
import Roles from './screens/admin/panel/Roles';
import UserRoles from './screens/admin/panel/UserRoles';
import UserProfiles from './screens/admin/panel/UserProfiles';
import Users from './screens/admin/panel/Users';
import Invites from './screens/admin/panel/UserInvites';
import InviteRegisterPage from './screens/admin/panel/UserInviteRegister';
import Translations from './screens/admin/panel/Translations';
import Spaces from './screens/admin/panel/Spaces';
import SpaceEditorPage from './screens/admin/panel/SpaceEditorPage';
import UserSpaces from './screens/admin/panel/UserSpaces';
import NotFound from './screens/admin/NotFound';
import {AdminLayout} from './components';
import React from "react";
import {ErrorBoundary} from "react-error-boundary";
import {Button} from "@mui/material";
import {AuthProvider} from './context/AuthProvider'
import {AdminMessageProvider} from './context/AdminMessageContext';
import './css/admin.css'
const Admin = () => {
    const navigate = useNavigate();


    return (
        <>
            <ErrorBoundary
                FallbackComponent={() => (
                    <ErrorFallback goBack={() => navigate(-1)}/>
                )}
                onError={console.error}
            >
                <AdminMessageProvider>

                    <AuthProvider>
                        <AdminLayout showAdminNavigation={true}>
                            <Routes>
                                {/* OPEN ROUTES*/}
                                <Route path='/' element={<Home/>}/>
                                <Route path='/login' element={<Login/>}/>
                                <Route path='/forgot-password' element={<ForgotPassword/>}/>
                                <Route path='/reset-password/:restToken' element={<ResetPassword/>}/>
                                <Route path='/invite' element={<InviteRegisterPage/>}/>

                                {/* AUTH ROUTES*/}
                                <Route element={<RequireAuth/>}>
                                    {/*<Route path='/' element={<Home/>}/>*/}
                                    <Route path='/account/profile' element={<MyProfile/>}/>
                                    <Route path='/client-permissions' element={<ClientPermissions/>}/>
                                    <Route path='/permissions' element={<Permissions/>}/>
                                    <Route path='/roles' element={<Roles/>}/>
                                    <Route path='/translations' element={<Translations/>}/>
                                    <Route path='/user-roles' element={<UserRoles/>}/>
                                    <Route path='/user-profiles' element={<UserProfiles/>}/>
                                    <Route path='/user-spaces' element={<UserSpaces/>}/>
                                    <Route path='/users' element={<Users/>}/>
                                    <Route path='/spaces/new' element={<SpaceEditorPage/>}/>
                                    <Route path='/spaces/:id/edit' element={<SpaceEditorPage/>}/>
                                    <Route path='/spaces' element={<Spaces/>}/>
                                    <Route path='/invites' element={<Invites/>}/>
                                    {/*<Route path='/products' element={<Products/>}/>*/}
                                </Route>

                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </AdminLayout>
                    </AuthProvider>
                </AdminMessageProvider>
            </ErrorBoundary>
        </>
    )
}

function ErrorFallback({error, goBack}) {
    const errorMessage = error && error.message ? error.message : "Unknown error";

    const clearLocalStorage = () => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userRole');
        goBack(); // Trigger goBack after clearing local storage
    };


    return (
        <AdminLayout showAdminNavigation={false}>

            <div className="main-user-error-message-block">
                <div className="user-error-message-block">
                    <p>Something went wrong 😭</p>
                    <span>Error: {errorMessage}</span>
                    <p>-</p>
                    <p>
                        <Link to={"/"} className="shop_go_to_frontend_link">
                            GO TO FRONTEND
                        </Link>
                    </p>
                    <p>
                        <Button onClick={goBack}>Go Back</Button>
                    </p>
                    <p>
                        <Button onClick={clearLocalStorage}>
                            Clear Local Storage and Go Back
                        </Button>
                    </p>
                </div>
            </div>
        </AdminLayout>

    );
}

export default Admin
